import React, { useCallback, useEffect, useState } from 'react';
import "../assets/css/styles.table.css"
import Box from '@mui/material/Box';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import Layout from './Layout';
import {useListPOEngHook} from '../hook/ListPOEngHook'
import GridNumberPaging from '../components/GridNumberPaging';
import Bindcomponent from '../utils/bindcomponent';
const ListPOEng = () => {
 
  const {message,setmessage,tipe,settipe,columns,rows,filterModel,setFilterModel,columnVisibilityModel,setColumnVisibilityModel, openAliast,setOpenAlias,GetStatus,fetchData,selectedData,selectedOptionStatus,setRows,handleSelectedProject,list,
    openAdd,setOpenAdd,openEdit,setOpenEdit,projectData
  } = useListPOEngHook()
  
  return (
    <>
      <Layout message={message} setmessage={setmessage} tipe={tipe} settipe={settipe}>
      <div className='pd'><b> Project List</b></div>
      <div className="pd">
      <Box>
      <Bindcomponent component='DynamicSelect'  label={`{id} - {name} `} value={"id"} selectedvalue={selectedOptionStatus}  onChange={(option) => {
                                              handleSelectedProject(option)
                                             }}
                                          url={"GetStatusByParentId"} id="projectSelect" disabled={false} required={false} appendTopOption={[{label :'ALL STATUS', value :0}]}></Bindcomponent>  
       <Box sx={{ height: "100%", marginTop:2 }}>
        
         <Bindcomponent component='GridNumberPaging' customcolumns={columns} rows={list} name={"listpogrid"} rowid={"id"} columvisibility={{id :false, id_project:false,assigned_by:false,updated_by:false}}></Bindcomponent>  
       {/* <GridNumberPaging customcolumns={columns} rows={rows} name={"listpogrid"} rowid={"id"} columvisibility={{id :false, id_project:false,assigned_by:false,updated_by:false}}></GridNumberPaging>   */}
        {/* <DataGrid className='fonty'
          columns={columns}
          rows={rows}
          disableColumnSelector
          disableColumnFilter
          disableDensitySelector
          slots={{ toolbar: GridToolbar }}
          wrap={true}
          filterModel={filterModel}
          onFilterModelChange={(newModel) => setFilterModel(newModel)}
          slotProps={{ toolbar: { showQuickFilter: true } }}
          columnVisibilityModel={columnVisibilityModel}
          onColumnVisibilityModelChange={(newModel) =>
            setColumnVisibilityModel(newModel)
          }
          getRowId={(row) => row.id}
        /> */}
      </Box>
    </Box>
    </div>
  </Layout>
    <Bindcomponent component='Dialog' open={openAliast} setOpen={setOpenAlias} maxWidth='sm' title={"ADD ALIAS PROJECT"} subtitle={""} >
              <Bindcomponent component='AliasProject' id={selectedData.id_project} name={selectedData.nama_project} projectalias={selectedData.alias_project} message={setmessage}  bind={async () => {
                      GetStatus(); 
                      fetchData()
                      setOpenAlias(false)
                }} />   
          
        </Bindcomponent>

        <Bindcomponent component='Dialog' open={openAdd} setOpen={setOpenAdd} maxWidth='md' title={"CREATE M.O.M"} subtitle={""} >
                  <Bindcomponent component='MomAddV2'  message={setmessage} projectData={projectData} />   
               
            </Bindcomponent>

             <Bindcomponent component='Dialog' open={openEdit} setOpen={setOpenEdit} maxWidth='md' title={"CREATE M.O.M"} subtitle={""} >
                  <Bindcomponent component='MomEditV2'  message={setmessage}   momData={projectData}/>   
               
            </Bindcomponent>
    </>
  );
};

export default ListPOEng;